import React, { useState, useEffect, useRef } from "react";
import { Box, Container, Grid, Typography, Card, Avatar, CardProps } from "@mui/material";
import { styled } from "@mui/system";
import { keyframes } from "@mui/system";

// ConservAqua
import ConservAquaLogo from "./../assets/Homepage - Testimonial - ConservAqua - Logo.jpg";
import ConservAquaHeadshot from "./../assets/Homepage - Testimonial - ConservAqua - Mark Hanlon.jpg";
// TheThriveHub
import TheThriveHubLogo from "./../assets/Homepage - Testimonial - TheThriveHub - Logo.jpg";
import TheThriveHubHeadshot from "./../assets/Homepage - Testimonial - TheThriveHub - Helen Anderson.jpg";
// Staingard
import StaingardLogo from "./../assets/Homepage - Testimonial - Staingard - Logo.jpg";
import StaingardHeadshot from "./../assets/Homepage - Testimonial - Staingard - Paul Aiston.jpg";
// Compass
import CompassLogo from "./../assets/Homepage - Testimonial - Compass - Logo.jpg";
import CompassHeadshot from "./../assets/Homepage - Testimonial - Compass - Andrew Gunn.jpg";
// VeloLife
import VeloLifeLogo from "./../assets/Homepage - Testimonial - VeloLife - Logo.jpg";
import VeloLifeHeadshot from "./../assets/Homepage - Testimonial - VeloLife - Jonathan Woods.jpg";


const fadeIn = keyframes`
    from { opacity: 0; transform: translateY(20px); }
    to { opacity: 1; transform: translateY(0); }
`;

const StyledLogoCard = styled(Card)((props: CardProps & { active: boolean }) => ({
    padding: "5px",
    cursor: "pointer",
    transition: "all 0.3s ease",
    filter: props.active ? "grayscale(0)" : "grayscale(1)",
    opacity: props.active ? 1 : 0.6,
    "&:hover": {
        filter: "grayscale(0)",
        opacity: 1,
        transform: "translateY(-5px)"
    }
}));

const TestimonialContent = styled(Box)({
    animation: `${fadeIn} 0.5s ease-out`,
    padding: "40px 0"
});

const testimonials = [
    {
        id: 1,
        company: "ConservAqua",
        logo: ConservAquaLogo,
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed ac libero at metus luctus fermentum. Nullam nec nisl nec nisl tincidunt ultricies. Nullam nec nisl nec nisl tincidunt ultricies.",
        author: "Mark Hanlon",
        position: "Company Director, ConservAqua",
        avatar: ConservAquaHeadshot
    },
    {
        id: 2,
        company: "The Thrive Hub",
        logo: TheThriveHubLogo,
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed ac libero at metus luctus fermentum. Nullam nec nisl nec nisl tincidunt ultricies. Nullam nec nisl nec nisl tincidunt ultricies.",
        author: "Helen Anderson",
        position: "Partner, The Thrive Hub",
        avatar: TheThriveHubHeadshot
    },
    {
        id: 3,
        company: "Staingard",
        logo: StaingardLogo,
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed ac libero at metus luctus fermentum. Nullam nec nisl nec nisl tincidunt ultricies. Nullam nec nisl nec nisl tincidunt ultricies.",
        author: "Paul Aiston",
        position: "Owner, Staingard",
        avatar: StaingardHeadshot
    },
    {
        id: 4,
        company: "Compass & Spectre Ltd",
        logo: CompassLogo,
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed ac libero at metus luctus fermentum. Nullam nec nisl nec nisl tincidunt ultricies. Nullam nec nisl nec nisl tincidunt ultricies.",
        author: "Andrew Gunn",
        position: "Director, Compass Garden Machinery",
        avatar: CompassHeadshot
    },
    {
        id: 5,
        company: "VeloLife",
        logo: VeloLifeLogo,
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed ac libero at metus luctus fermentum. Nullam nec nisl nec nisl tincidunt ultricies. Nullam nec nisl nec nisl tincidunt ultricies.",
        author: "Jonathan Woods",
        position: "Director, VeloLife",
        avatar: VeloLifeHeadshot
    }
];

export default () => {
    const [ activeIndex, setActiveIndex ] = useState(0);

    const lastChangeTime = useRef(new Date().getTime());

    useEffect(() => {
        const timer = setInterval(() => {
            if(new Date().getTime() - lastChangeTime.current < 10000) return;
            setActiveIndex((prev) => (prev + 1) % testimonials.length);
            lastChangeTime.current = new Date().getTime();
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    const handleLogoClick = (index: number) => {
        setActiveIndex(index);
        lastChangeTime.current = new Date().getTime();
    };

    return (
        <Container sx={{ pt: 8 }}>
            <Grid container spacing={4} justifyContent="center" mb={1}>
                {testimonials.map((testimonial, index) => (
                    <Grid item xs={6} sm={2} key={testimonial.id}>
                        <StyledLogoCard
                        active={index === activeIndex}
                        onClick={() => handleLogoClick(index)}
                        elevation={index === activeIndex ? 4 : 1}
                        >
                        <Box
                            component="img"
                            src={testimonial.logo}
                            alt={testimonial.company}
                            sx={{
                                width: "100%",
                                height: "100%",
                            }}
                        />
                        </StyledLogoCard>
                    </Grid>
                ))}
            </Grid>

            <TestimonialContent>
                <Typography
                    fontFamily="Raleway"
                    component="p"
                    textAlign="center"
                    mb={4}
                    fontSize="18px"
                    sx={{ 
                        fontStyle: "italic",
                        '@media (max-width: 600px)': {
                            fontSize: '16px',
                        },
                    }}
                    color="#212529"
                >
                    {testimonials[activeIndex].quote}
                </Typography>

                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 2
                    }}
                >
                    <Avatar
                        src={testimonials[activeIndex].avatar}
                        alt={testimonials[activeIndex].author}
                        sx={{ width: 64, height: 64 }}
                    />
                    <Box sx={{
                        height: "100%",
                        justifyContent: "center",
                    }}>
                        <Typography fontFamily="Red Rose" component="p" color="#3b0e59" fontSize="24px" sx={{
                            '@media (max-width: 600px)': {
                                fontSize: '20px',
                            },
                        }}>
                            {testimonials[activeIndex].author}
                        </Typography>
                        <Typography fontFamily="Raleway" component="p" color="#212529" fontSize="14px" sx={{
                            '@media (max-width: 600px)': {
                                fontSize: '12px',
                            },
                        }}>
                            {testimonials[activeIndex].position}
                        </Typography>
                    </Box>
                </Box>
            </TestimonialContent>
        </Container>
    );
};